import { MODULES } from "./rbac";

export const MENU_CONFIG = [
    { key: MODULES.DASHBOARD, label: "Dashboard" },
    { key: "monitoring", label: "Monitoring" },
    { key: MODULES.MONITORING_CCTV, label: "Monitoring CCTV" },
    { key: MODULES.MONITORING_STOCK, label: "Monitoring Stock" },
    { key: MODULES.MONITORING_USER_ACTIVITY, label: "Monitoring User Activity" },
    { key: MODULES.MONITORING_ANTI_FRAUD, label: "Monitoring Anti Fraud" },
    { key: MODULES.CUSTOMS, label: "Customs Report" },
    { key: MODULES.INVENTORY, label: "Inventory" },
    { key: MODULES.PITA_CUKAI, label: "Pita Cukai" },
    { key: MODULES.FINANCE, label: "Finance" },
    { key: MODULES.PORTAL, label: "Portal" },
    { key: MODULES.REFERENSI, label: "Master Data (Referensi)" },
    { key: MODULES.OTHERS, label: "Others" },
    { key: MODULES.EMAIL, label: "E-Mail" },
    { key: MODULES.ROLE_ACCESS, label: "Akses Role" }
];
